// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure that the table wrapper has a fixed height and overflow properties */
.table-wrapper {
    max-height: 200px; /* Set this height based on your requirement */
    overflow-y: auto;
    overflow-x: hidden;
    border: 1px solid #ddd; /* Optional: to add a border around the table */
    margin-bottom: 20px; /* Optional: spacing below the table */
}

.small-table {
    width: 400px;
    border-collapse: collapse;
}

.small-table th, .small-table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
}

.small-table th {
    background-color: #f4f4f4;
}

.selected {
    background-color: #e0e0e0; /* Highlight the selected row */
}

.search-input {
    width: 75%;
    margin-bottom: 10px;
    border: 1px solid #ddd;
    border-radius: 100px;
    padding: 15px;
    direction: rtl;
}

.operationCont {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.actionOfPatientContainer {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.moveToRoomBtn {
    margin-left: 10px;
    padding: 10px 20px;
    border: none;
    background-color: #007bff;
    color: white;
    border-radius: 4px;
    cursor: pointer;
}

.moveToRoomBtn:disabled {
    background-color: #6c757d;
}

.finishTreatment {
    display: flex;
    align-items: center;
    background-color: #28a745;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 10px 20px;
    cursor: pointer;
}

.finishTreatment:disabled {
    background-color: #6c757d;
}

.finishTreatment div {
    margin-left: 8px;
}
.MorePatientOptionsCont{
    width:50%;
}
.MorePatientOptionsContainer{
    background-color: rgb(255, 255, 255);
    border-radius: 20px;
    padding: 40px;
    margin: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.selectedPatientCont{
    display: flex;
    border-radius: 100px;
    background-color: #ebf4ff;
    flex-direction: column;
    padding: 10px;
    width: 80%;
    margin: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/DoctorPage/MorePatientOptions.css"],"names":[],"mappings":"AAAA,6EAA6E;AAC7E;IACI,iBAAiB,EAAE,8CAA8C;IACjE,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB,EAAE,+CAA+C;IACvE,mBAAmB,EAAE,sCAAsC;AAC/D;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB,EAAE,+BAA+B;AAC9D;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,SAAS;AACb;AACA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,UAAU;IACV,YAAY;AAChB","sourcesContent":["/* Ensure that the table wrapper has a fixed height and overflow properties */\r\n.table-wrapper {\r\n    max-height: 200px; /* Set this height based on your requirement */\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    border: 1px solid #ddd; /* Optional: to add a border around the table */\r\n    margin-bottom: 20px; /* Optional: spacing below the table */\r\n}\r\n\r\n.small-table {\r\n    width: 400px;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.small-table th, .small-table td {\r\n    border: 1px solid #ddd;\r\n    padding: 8px;\r\n    text-align: center;\r\n}\r\n\r\n.small-table th {\r\n    background-color: #f4f4f4;\r\n}\r\n\r\n.selected {\r\n    background-color: #e0e0e0; /* Highlight the selected row */\r\n}\r\n\r\n.search-input {\r\n    width: 75%;\r\n    margin-bottom: 10px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 100px;\r\n    padding: 15px;\r\n    direction: rtl;\r\n}\r\n\r\n.operationCont {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n}\r\n\r\n.actionOfPatientContainer {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.moveToRoomBtn {\r\n    margin-left: 10px;\r\n    padding: 10px 20px;\r\n    border: none;\r\n    background-color: #007bff;\r\n    color: white;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n}\r\n\r\n.moveToRoomBtn:disabled {\r\n    background-color: #6c757d;\r\n}\r\n\r\n.finishTreatment {\r\n    display: flex;\r\n    align-items: center;\r\n    background-color: #28a745;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    padding: 10px 20px;\r\n    cursor: pointer;\r\n}\r\n\r\n.finishTreatment:disabled {\r\n    background-color: #6c757d;\r\n}\r\n\r\n.finishTreatment div {\r\n    margin-left: 8px;\r\n}\r\n.MorePatientOptionsCont{\r\n    width:50%;\r\n}\r\n.MorePatientOptionsContainer{\r\n    background-color: rgb(255, 255, 255);\r\n    border-radius: 20px;\r\n    padding: 40px;\r\n    margin: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.selectedPatientCont{\r\n    display: flex;\r\n    border-radius: 100px;\r\n    background-color: #ebf4ff;\r\n    flex-direction: column;\r\n    padding: 10px;\r\n    width: 80%;\r\n    margin: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
